import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const navigate = useNavigate();

  const handleLogin = (e) => {
  e.preventDefault();

  // ✅ Admin Login
  if (
    credentials.username === 'Vasantha' &&
    credentials.password === 'SriDorasani@vasantha'
  ) {
    localStorage.setItem('role', 'admin');
    navigate('/admin');
  } 
  // ✅ Customer Login (ANY USER)
  else if (credentials.username && credentials.password) {
    localStorage.setItem('role', 'customer');
    navigate('/');
  } 
  else {
    alert('Invalid Credentials!');
  }
};

  return (
    <div className="min-h-screen bg-cream flex items-center justify-center p-4">
      <div className="bg-white p-10 shadow-xl border-t-8 border-maroon w-full max-w-md">
        <div className="text-center mb-8">
          <img src="/logo.png" alt="Logo" className="h-20 mx-auto mb-4" />
          <h2 className="text-2xl font-serif text-maroon font-bold uppercase tracking-widest">Login</h2>
          <p className="text-gray-500 text-sm italic">Sri Dorasani Collections Portal</p>
        </div>

        <form onSubmit={handleLogin} className="space-y-6">
          <div>
            <label className="block text-xs font-bold text-maroon uppercase mb-2">Username</label>
            <input 
              type="text" 
              className="w-full border-b-2 border-gray-200 p-2 focus:border-maroon outline-none transition"
              onChange={(e) => setCredentials({...credentials, username: e.target.value})}
              required
            />
          </div>
          <div>
            <label className="block text-xs font-bold text-maroon uppercase mb-2">Password</label>
            <input 
              type="password" 
              className="w-full border-b-2 border-gray-200 p-2 focus:border-maroon outline-none transition"
              onChange={(e) => setCredentials({...credentials, password: e.target.value})}
              required
            />
          </div>
          <button 
            type="submit" 
            className="w-full bg-maroon text-white py-3 font-bold hover:bg-black transition uppercase tracking-widest shadow-md"
          >
            Sign In
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;